import { sumBy } from 'lodash';
import { Order } from '@/type';
import DataCenter from '@/modules/data/DataCenter';

export const formatCurrency = (currency?: number, language?: string) => {
  return !currency
    ? 0
    : currency.toLocaleString(language, {
        style: 'currency',
        currency: 'EUR',
      });
};

export const sumWithDeliveryFee = (orders?: Order[], postalCode?: string) => {
  console.log(postalCode);
  const price = sumBy(orders, (item: Order) => {
    return item.price * item.quantity;
  });
  // const selfTaken = price && price < 30;
  // let distanceDeliveryFee = undefined;
  //
  // _.each(DataCenter.DELIVERY_PLZ, (values, key) => {
  //     if (values.indexOf(postalCode) > -1) {
  //         distanceDeliveryFee = DataCenter.DELIVERY_FEE_PLZ[key];
  //     }
  // });

  // const deliveryFee = selfTaken || !price ? 0 : distanceDeliveryFee;
  return {
    price: Math.round((price + Number.EPSILON) * 100) / 100,
    deliveryFee: undefined,
    selfTaken: true,
  };
};

export const handleOrderInformation = (Order: Order, language: string) => {
  let name = Order.nameDe;
  let description = Order.descriptionDe;
  if (language === DataCenter.SUPPORT_LANGUAGE.en.language) {
    name = Order.nameEn;
    description = Order.descriptionEn;
  } else if (language === DataCenter.SUPPORT_LANGUAGE.zh.language) {
    name = Order.nameZn;
    description = Order.descriptionZn;
  }
  return {
    name,
    description,
  };
};
